{
  "language": {
    "fr": "Faransi",
    "en": "Glensi",
    "fon": "Fɔn",
    "yo": "Yoruba",
    "bba": "Baatɔnum"
  }
}
